export default "__VITE_ASSET__BCK3K1tw__"